const {
  SOURCE_VGTM,
} = require('./../../../../sourceList')
const {
  GENDER_FEMALE,
} = require('./../../../../genderList')
const {
  CR_1,
} = require('./../../../../crList')
const {
  SIZE_TINY,
} = require('./../../../../sizeList')
const {
  CREATURE_TYPE_FIEND,
} = require('./../../../../creatureTypeIdList')
const {
  LANG_ABYSSAL,
  LANG_ALL_KNOWN_AT_LIFE,
  LANG_INFERNAL,
} = require('./../../../../languageIdList')
const {
  ALIGNMENT_CE,
} = require('./../../../../aligmentList')
const {
  SPEED_WALK,
  SPEED_FLY,
} = require('./../../../../speedList')
const {
  CONDITION_POISONED,
} = require('./../../../../conditionList')
const {
  ATTACK_MELEE_WEAPON,
} = require('./../../../../attackTypeList')
const {
  DAMAGE_COLD,
  DAMAGE_ELECTRICITY,
  DAMAGE_FIRE,
  DAMAGE_PIERCING,
  DAMAGE_POISON,
} = require('./../../../../damageTypeList')
const {
  SENSE_DARK_VISION,
} = require('./../../../../senseList')
const {
  PARAM_STR,
  PARAM_DEX,
  PARAM_CON,
  PARAM_INT,
  PARAM_WIT,
  PARAM_CHA,
} = require('./../../../../paramList')
const {
  SPELL_DAYLIGHT,
  SPELL_GREATER_RESTORATION,
  SPELL_REMOVE_CURSE,
} = require('./../../../../spellIdList')
const {
  CREATURE_DRETCH,
  CREATURE_MANES,
  CREATURE_VARGOUILLE,
} = require('./../../../../creatureIdList')

module.exports = {
  name: 'Варгулья',
  nameEn: 'Vargouille',
  id: CREATURE_VARGOUILLE,
  description: [
    {
      header: 'Варгулья',
      text: `Визжащая, порхающая и отвратная на вид, с телом в виде отделённой от туловища головы и крыльями как у летучей мыши на месте ушей, варгулья вылетает из Бездны на другие планы существования, например, Карцери, где становится угрозой. Каждая варгулья разносит болезнь, которая производит новых варгулий. Стая летящих варгулий — верный признак скорого распространения чумы зла и хаоса.`,
      source: {
        id: SOURCE_VGTM,
        page: 131,
      },
    },
    {
      header: 'Неприятности из Бездны',
      text: `Рои варгулий порхают по небу и в пещерах Бездны. Могущественные и умные демоны не обращают на них внимания, так как варгульи не могут причинить им вреда.

Даже самые слабые демоны, такие, как [мэйны](CREATURE:${CREATURE_MANES}) или [дретчи](CREATURE:${CREATURE_DRETCH}), опасаются варгулий только если те появляются в больших количествах. На Нижних планах у варгулий редко бывает возможность съесть живую жертву помимо мелких вредителей. Чаще всего им приходится лакать ихор, остающийся после убийства одним демоном другого.`,
      source: {
        id: SOURCE_VGTM,
        page: 131,
      },
    },
    {
      header: 'Мир ждёт',
      text: `Из-за своего инстинктивного голода и желания полакомиться живой добычей, варгульи стремятся покинуть Нижние планы.

В редких случаях при вызове демона на другой план варгулья попадает туда тоже, прицепившись за демона как репейник.`,
      source: {
        id: SOURCE_VGTM,
        page: 131,
      },
    },
    {
      header: 'Ужасное размножение',
      text: `Свободно летающие по Материальному плану варгульи — страшная угроза для всех существ, в особенности, для гуманоидов. Их ужасный визг может парализовать страхом других существ, и такие жертвы становятся беззащитными против проклятого поцелуя варгульи. Предосторожности, которые предпринимают смертные для контроля призванного демона, редко предусматривают наличие случайного пассажира на нём, так что варгулья может улететь свободно. Поцелуй варгульи заражает гуманоида адским проклятьем. Если ему позволить подействовать, проклятье вызывает отвратительную трансформацию и проникновение духа Бездны в тело. За несколько часов на голове жертвы появляются демонические черты, например клыки, рога или щупальца. В то же время уши жертвы вырастают и преобразуются в нечто подобное крыльям летучей мыши. Наконец, голова жертвы отрывается от туловища, что сопровождается фонтаном крови, и становится новой варгульей, которая при этом может сразу же начать жадно питаться жизненными соками собственного бывшего тела. Солнечный свет или яркое освещение может замедлить эту трансформацию, так что варгульи инстинктивно сторонятся яркого света.`,
      source: {
        id: SOURCE_VGTM,
        page: 131,
      },
    },
  ],
  note: {
    text: `До тех пор, пока ты не увидел, как голова короля, оторвавшись от его плеч, не взлетела над фонтаном крови, затем чтобы вгрызться в свои собственные, падающие на пол из брюха, потроха — до тех пор ты не видел в жизни ничего! И если тебе всё ещё хочется пожить, то следует прекратить глазеть и бежать!`,
    author: `Эльминстер`,
  },
  sizeType: SIZE_TINY,
  creatureTypeIdList: [
    CREATURE_TYPE_FIEND,
  ],
  alignmentId: ALIGNMENT_CE,
  source: {
    id: SOURCE_VGTM,
    page: 131,
  },
  armor: 12,
  hp: {
    diceCount: 3,
  },
  speed: {
    [SPEED_WALK]: 5,
    [SPEED_FLY]: 40,
  },
  params: {
    [PARAM_STR]: 6,
    [PARAM_DEX]: 14,
    [PARAM_CON]: 14,
    [PARAM_INT]: 4,
    [PARAM_WIT]: 7,
    [PARAM_CHA]: 2,
  },
  resistanceList: [
    DAMAGE_COLD,
    DAMAGE_ELECTRICITY,
    DAMAGE_FIRE,
  ],
  immunityList: [
    DAMAGE_POISON,
  ],
  immunityConditionList: [
    CONDITION_POISONED,
  ],
  senseList: [
    {
      id: SENSE_DARK_VISION,
      value: 60,
    },
  ],
  languageList: [
    {
      id: [
        LANG_ABYSSAL,
        LANG_INFERNAL,
        LANG_ALL_KNOWN_AT_LIFE,
      ],
      doNotSpeak: true,
    },
  ],
  cr: CR_1,
  actionList: [
    {
      name: 'Укус',
      attack: {
        type: ATTACK_MELEE_WEAPON,
        bonus: 4,
        range: 5,
        hit: [
          {
            type: DAMAGE_PIERCING,
            diceCount: 1,
            diceType: 6,
            diceBonus: 2,
          },
          {
            type: DAMAGE_POISON,
            diceCount: 3,
            diceType: 6,
            diceBonus: 0,
          },
        ],
      },
    },
    {
      name: 'Поцелуй',
      description: `★СУЩЕСТВО★ целует одного недееспособного гуманоида в пределах 5 футов. Цель должна пройти испытание Харизмы СЛ 12 или стать проклятой. Проклятая цель теряет 1 очко Харизмы каждый час, а её голова принимает извращённые изменения. Проклятие не прогрессирует, пока цель находится в области солнечного света или под действием заклинания [Дневной свет](SPELL:${SPELL_DAYLIGHT}) и это время не учитывается. Когда Харизма проклятого существа становится равна 2, оно умирает и его голова отрывается от тела и становится новой варгульей. Если сотворить на цель [Снятие проклятья](SPELL:${SPELL_REMOVE_CURSE}), [Высшее восстановление](SPELL:${SPELL_GREATER_RESTORATION}) или похожее заклинание до того, как трансформация завершится, то проклятие снимется. В таком случае отменяются изменения цели, сделанные проклятием.`,
    },
    {
      name: 'Ошеломляющий визг',
      description: `★СУЩЕСТВО★ визжит. Каждый способный ★его★ слышать гуманоид и зверь в пределах 30 футов должен пройти испытание Мудрости СЛ 12 или стать Испуганным до конца следующего хода ★СУЩЕСТВО★. Испуганные таким образом цели Ошеломлены. Если цели прошла испытание или эффект для неё закончен, то она получает иммунитет к _Ошеломляющему визгу_ всех варгулий на 1 час.`,
    },
  ],
  genderId: GENDER_FEMALE,
}
